import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { OpenPopupButton } from './styles';

import { ReactComponent as IconSettings } from 'icons/icon-settings.svg';

import { selectSubscriptionsForEntity } from 'redux/reducers/subscriptions';
import {
  setShowArtistSettings,
  TArtist,
} from '../../../redux/reducers/notificationModals';

const SubscribeButton: React.FC<INotificationsSettingsProps> = (props) => {
  const { entityName, entityId } = props;

  const dispatch = useDispatch();

  function openSettings(artist: TArtist): void {
    dispatch(setShowArtistSettings(artist));
  }

  const subscriptionsForEntity = useSelector(
    selectSubscriptionsForEntity(entityId)
  );

  return (
    <OpenPopupButton
      className={subscriptionsForEntity ? 'subscribed' : ''}
      onClick={(): void => {
        openSettings({ entityId, entityName });
      }}
    >
      {subscriptionsForEntity ? <IconSettings /> : null}
      {subscriptionsForEntity ? 'subscriptions' : 'subscribe'}
    </OpenPopupButton>
  );
};

interface INotificationsSettingsProps {
  entityName: string;
  entityId: string;
}

export default SubscribeButton;
